import React, { } from 'react';
import {
  CheckCircleOutlined,
  CloseOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, Card, message, Space, theme, Upload } from 'antd';
import { KAPTAIN_URL } from '../../../services/config';
const { useToken } = theme;

type CustomUploadCompProps = {
  accept: string;
  fileName: string;
  value?: string;
  onChange?: (value?: string) => void;
};

const CustomUploadComp: React.FC<CustomUploadCompProps> = ({ accept, fileName, value, onChange }) => {
  const { token } = useToken();

  const importProps = {
    name: 'file',
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    },
    showUploadList: false,
    onChange: async (info: any) => {
      if (info.file.status === 'done') {
        message.success('Uploaded successfully!');
        onChange && onChange(info.file.response);
      } else if (info.file.status === 'error') {
        message.error(info.file.response.message);
      }
    },
  };

  return (
    <>
      {value ? (
        <Card size='small' bordered>
          <Space size={'small'}>
            <span>
              <CheckCircleOutlined
                style={{
                  marginRight: 4,
                  color: token.colorSuccess,
                }}
              />
              <span>Uploaded!</span>
            </span>
            <Button onClick={() => { onChange && onChange() }} danger type='text' size='small'>remove</Button>
          </Space>
        </Card>
      ) : (
        <Upload
          {...importProps}
          listType="text"
          maxCount={1}
          accept={accept}
          action={`${KAPTAIN_URL}/configuration/sys/upload/file/${fileName}`}
        >
          <Button icon={<UploadOutlined />}>upload</Button>
        </Upload>
      )}
    </>
  );
};

export default CustomUploadComp;
